import React, { useRef, useState } from "react";

// styles
import styleMain from "./FileFacilities.module.css";

const removeDuplicates = array => {
  const uniqueMap = new Map();

  array?.forEach(item => {
    if (!uniqueMap.has(item.title)) {
      uniqueMap.set(item.title, item);
    }
  });

  return Array.from(uniqueMap.values());
};

export default function FileFacilities(props) {
  let [isOpen, setIsOpen] = useState(false);
  let listRef = useRef(null);

  let titles = props?.facilitiData?.filter(item => {
    const subItems = props?.facilitiData?.filter(button => button.parentId === item.id && props.addedFacilitiesID?.includes(button.id));
    return subItems.length > 0;
  });

  const parikngCount = props?.cardData?.customSpecifications?.[0];

  let parkingTypeId = titles?.filter(val => val.title == "نوع و تعداد پارکینگ")[0]?.id || 0;

  titles = titles?.filter(val => val.title != "نوع و تعداد پارکینگ");

  let fileFacilities = props?.facilitiData?.filter(f => props.addedFacilitiesID?.includes(f.id));

  let hasParkingType = false;

  if (parkingTypeId != 0) {
    hasParkingType = true;
  }

  let middleIndex = Math.ceil(titles?.length / 2);
  let firstHalf = titles?.slice(0, middleIndex + 1);
  let secondHalf = titles?.slice(middleIndex + 1);

  console.log(
    titles,
    removeDuplicates(titles),
    props.facilitiData,
    props.addedFacilitiesID,
    props.addedFacilities,
    props.cardData,
    props,
    middleIndex,
    firstHalf,
    secondHalf
  );

  return (
    <div
      ref={listRef}
      className={`${styleMain.container}`}
      onClick={() => {
        setIsOpen(!isOpen);
      }}>
      <div className={`${styleMain.right_items}`}>
        {firstHalf?.map((item, i) => (
          <div className={`${styleMain.item}`}>
            <div className={`${styleMain.item_header}`}>{item.title}</div>
            <div className={`${styleMain.item_items}`}>
              {props?.facilitiData
                ?.filter(button => button.parentId === item.id && props.addedFacilitiesID?.includes(button.id))
                .map(button => (
                  <div className={`${styleMain.item_items_text}`}>{button.title}</div>
                ))}
            </div>
          </div>
        ))}
      </div>
      <div className={`${styleMain.left_items}`}>
        {secondHalf?.map((item, i) => (
          <div className={`${styleMain.item}`}>
            <div className={`${styleMain.item_header}`}>{item.title}</div>
            <div className={`${styleMain.item_items}`}>
              {props?.facilitiData
                ?.filter(button => button.parentId === item.id && props.addedFacilitiesID?.includes(button.id))
                .map(button => (
                  <div className={`${styleMain.item_items_text}`}>{button.title}</div>
                ))}
            </div>
          </div>
        ))}
        {hasParkingType ? (
          <div className={`${styleMain.item}`}>
            <div className={`${styleMain.item_header}`}>نوع و تعداد پارکینگ</div>
            <div className={`${styleMain.item_items}`}>
              <div className={`${styleMain.item_items_text}`}>
                {fileFacilities?.find(val => val.parentId == parkingTypeId)?.title} ( {parikngCount?.value?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])} )
              </div>
            </div>
          </div>
        ) : parikngCount != undefined && parikngCount?.value != 0 ? (
          <div className={`${styleMain.item}`}>
            <div className={`${styleMain.item_header}`}>تعداد پارکینگ</div>
            <div className={`${styleMain.item_items}`}>
              <div className={`${styleMain.item_items_text}`}>{parikngCount?.value?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
